
import { call, put } from 'redux-saga/effects'
import { path } from 'ramda'
import { AuthActions } from '../ducks/AuthRedux'

export function* logout(api, action) {
    
}